/* angular:styles/component:css;da9f060b00b1459648df22a10528d955fa9e093f564a9a09d350214db908431a;/src/src/app/shared/components/header/app-header.ts */
ion-title::part(native) {
  display: flex;
  justify-content: center;
  align-items: center;
}
/*# sourceMappingURL=app-header.css.map */
